import { ChatDiscussion } from '../entity';

export class ChatDiscussionSwitchedEvent {
  constructor(public discussions: ChatDiscussion) {}
}
